// extracted by mini-css-extract-plugin
export default {"icon":"Star_icon__riH4F"};